import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../context/AuthContext';

function ProfilePage() {
  const { user, logout } = useAuth();

  if (!user) {
    // Optional: Redirect to login or show a message if user is not logged in
    // For now, just showing minimal content or null
    return <div className="p-8 text-center text-gray-600 dark:text-dark-text-secondary">Please log in to view your profile.</div>;
  }

  // Use actual usage data from the user object
  const usage = user.monthlyRequestCount || 0;
  const limit = user.monthlyRequestLimit || 9999; // Use default if somehow missing

  return (
    <>
      <Helmet>
        <title>Your Profile</title>
        <meta name="description" content="View and manage your UIForge profile details and usage information." />
      </Helmet>

      <div className="p-8 max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-dark-text-primary">Profile</h1>
        
        <div className="bg-white dark:bg-dark-bg-secondary shadow-md rounded-lg p-6 mb-8">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-dark-text-secondary">Name</label>
            <p className="mt-1 text-lg text-gray-900 dark:text-dark-text-primary">{user.name || 'N/A'}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-dark-text-secondary">Email</label>
            <p className="mt-1 text-lg text-gray-900 dark:text-dark-text-primary">{user.email || 'N/A'}</p>
          </div>
        </div>

        <h2 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-dark-text-primary">Usage</h2>
        <div className="bg-white dark:bg-dark-bg-secondary shadow-md rounded-lg p-6 mb-8">
          <p className="text-gray-800 dark:text-dark-text-primary">
            Monthly requests: <span className="font-medium">{usage}</span> / <span className="font-medium">{limit}</span>
          </p>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5 mt-2">
            <div 
              className="bg-blue-600 dark:bg-dark-accent h-2.5 rounded-full" 
              // Ensure division by zero is handled if limit is 0 or undefined
              style={{ width: `${limit > 0 ? (usage / limit) * 100 : 0}%` }}
            ></div>
          </div>
        </div>

        {/* Add a logout button */}
        <button 
          onClick={logout}
          className="w-full mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 dark:bg-red-700 dark:hover:bg-red-800"
        >
          Logout
        </button>
      </div>
    </>
  );
}

export default ProfilePage; 